import Vue from 'vue'
import App from './App.vue'
import demo from './demo'

// import 'bulma/css/bulma.css'
// import './../node_modules/bulma/css/bulma.min.css'

require('./assets/sass/main.scss');

Vue.config.productionTip = false
Vue.use(demo)

new Vue({
  render: h => h(App),
}).$mount('#app')
